import { InjectionToken } from '@angular/core';
import { environment } from 'src/environments/environment';

export const API_URL = new InjectionToken<string>('api.url', {
  providedIn: 'root',
  factory: () => environment.serverUrl ?? `${globalThis.location.protocol}//${globalThis.location.host}/skilltree-api`,
});
